import { render, staticRenderFns } from "./RitualGold.vue?vue&type=template&id=3891ec29&scoped=true&"
import script from "./RitualGold.vue?vue&type=script&lang=js&"
export * from "./RitualGold.vue?vue&type=script&lang=js&"
import style0 from "./RitualGold.vue?vue&type=style&index=0&id=3891ec29&scoped=true&lang=scss&"
import style1 from "./RitualGold.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3891ec29",
  null
  
)

export default component.exports